export const COMMENT_THREAD_MEETING_STALE_MS = 4 * 60 * 60 * 1000;

export interface CommentThreadMeetingActiveFields {
  meetUrl: string;
  createdAt: Date | null;
  endsAt: Date | null;
  endedAt: Date | null;
}

export function isActiveCommentThreadMeeting(
  m: CommentThreadMeetingActiveFields | null,
  now = Date.now(),
): boolean {
  if (!m || m.endedAt) return false;
  if (m.endsAt && m.endsAt.getTime() <= now) return false;
  if (m.createdAt && now - m.createdAt.getTime() > COMMENT_THREAD_MEETING_STALE_MS) {
    return false;
  }
  return !!m.meetUrl;
}
